
export type EnrollmentCreateResponseOneOfResult = typeof EnrollmentCreateResponseOneOfResult[keyof typeof EnrollmentCreateResponseOneOfResult];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrollmentCreateResponseOneOfResult = {
  success: 'success',
} as const;
